import { useEffect, useState } from "react";
import "./managePrivacyStyle.css"
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { Button } from "primereact/button";
import { checkCardIsSelected, downloadFileFromBlob, goTo, isJsonParsable, returnCardInfo } from "../../utilities/common.utilities";
import { ManagePrivacyDataModel, PrivacyProfileModel, SetPrivacy } from "../../static/privacy.model";
import moment from "moment";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { setPrivacy } from "../../service/privacy.service";
import { getUserCards } from "../../service/card.service";
import cardModel from "../../static/card-model";
import { APP_ID_PLATFORM } from "../../static/constants";
import { Dialog } from "primereact/dialog";
import { getPrivacyDocument } from "../../service/privacyDoc.service";
import { useConnectivity } from "../../context/connectivityContext";
import { group } from "console";
import { useLocation } from "react-router-dom";

type ManagePrivacySelectedCard = {
    groupCode: string;
    storeCode: string;
    card: string;
};

type Theme =  "dark" | "high-contrast" | "light-blue";

export default function ManagePrivacyComponent(){

    const [privacy1, setPrivacy1] = useState<boolean>(false)
    const [privacy2, setPrivacy2] = useState<boolean>(false)
    const [privacy3, setPrivacy3] = useState<boolean | null>(null)
    const [dataManage, setDataManage] = useState<ManagePrivacyDataModel>()
    const [privacyInfo, setPrivacyInfo] = useState<PrivacyProfileModel>()
    const [card, setCard] = useState<ManagePrivacySelectedCard>({ groupCode: '', storeCode: '', card: '' })
    const [showVisibleResult, setShowVisibleResult] = useState<boolean>(false)
    const [groupName, setgroupName] = useState<string>()
    const [storeName, setStoreName] = useState<string>()
    const { isOnline } = useConnectivity();
    const [theme, setTheme] = useState<Theme>("light-blue");
    const location = useLocation();
    

    useEffect(()=> {
        const storedTheme = localStorage.getItem("theme") as Theme | null;
        if (storedTheme) {
          setTheme(storedTheme);
        }
        if(!isJsonParsable(localStorage.getItem('managePrivacyData'))) {
            goTo('/home')
        }
        else {
            initComponent();
        }

    },[isOnline, location])  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore
    

    const footerContent = (
        <div>
          <Button
            label="Ok"
            icon="pi pi-check"
            onClick={() => {
              setShowVisibleResult(false);
              if(dataManage?.pathname === '/menu') {
                // goTo('/menu');
                window.history.go(-1)
              }
              else {
                goTo('/home');
              }
            }}
            autoFocus
          />
        </div>
      );

    const initComponent = () => {
        let dataLocalStorage: ManagePrivacyDataModel = JSON.parse(localStorage.getItem('managePrivacyData') || '""');

        let cardCheck: string = dataLocalStorage.privacyInfo.card

        getUserCards().then((cardData: cardModel) => {

            
          if (cardData?.cards.length > 0) {

            let cardPrivacy = cardData.cards.find( c => c.cardNumber === cardCheck )

              if(cardPrivacy){
                  let cardSelected: ManagePrivacySelectedCard = {
                    groupCode: cardPrivacy.groupId.toString(),
                    storeCode: cardPrivacy.mainStoreCode,
                    card: cardPrivacy?.cardNumber
                  };
                  setCard(cardSelected)
                  setStoreName(cardPrivacy.mainStoreName)             
                  setgroupName(cardPrivacy.groupName)

              }

              getPrivacy()
            }
          
        });
    };

    const getPrivacy = () => {

        let dataLocalStorage: ManagePrivacyDataModel = JSON.parse(localStorage.getItem('managePrivacyData') || '""');
        setDataManage(dataLocalStorage);

        let privacyInfo: PrivacyProfileModel = dataLocalStorage.privacyInfo;

        if(privacyInfo) {
            setPrivacy1(privacyInfo.privacy1 ? true : false);
            setPrivacy2(privacyInfo.privacy2 ? true : false);

            if(privacyInfo.privacy3App) {
                setPrivacy3(privacyInfo.privacy3App.value ? true : false);
            }
    
            setPrivacyInfo(privacyInfo);
        }
     
    }


    const onChangePrivacy1 = (e:CheckboxChangeEvent) => {
        setPrivacy1(!privacy1)
    }
    const onChangePrivacy2 = (e:CheckboxChangeEvent) => {
        setPrivacy2(!privacy2)
    }
    const onChangePrivacy3 = (e:CheckboxChangeEvent) => {
        setPrivacy3(!privacy3)
    }

    const confirmSaveSetting = () => confirmDialog({
        message: 'Aggiornare i consensi della privacy?',
        header: "Conferma operazione",
        className: "dialog-conferma-privacy",
        acceptLabel: "Si",
        modal: true,
        accept: () => {
            saveSettingPrivacy()
        }
    })

    const downloadPdfPrivacy = () => {

        getPrivacyDocument(card.groupCode,card.storeCode,card.card).then(data_base64 => {
            const myBuffer = Uint8Array.from(atob(data_base64), c => c.charCodeAt(0));
            let file = new Blob([myBuffer], {type: 'application/pdf;charset=utf-8'});
            
            let now: Date = new Date();
            let nomeFile: string = 'InformativaPrivacy_'+ now.getFullYear()+'_'+now.getMonth()+'_'+now.getDate();
            downloadFileFromBlob(file, nomeFile)
        });
    }

    function saveSettingPrivacy() {
        let request: SetPrivacy = {
            groupCode: card.groupCode,
            storeCode: card.storeCode,
            card: card.card,
            privacy1: privacy1,
            privacy2: privacy2,
            privacyUpdateOverrides: { platformId: APP_ID_PLATFORM },
        } 

        if(privacyInfo?.privacy3App) {
            request.privacy3 = privacy3 ? true : false
        }

        setPrivacy(request).then((response: string) => {
            if(response === 'OK') {
                // ad operazione avvenuta con successo, pulisco i dati in localstorage riguardanti la privacy 
                localStorage.removeItem("GET_PRIVACY_PROFILE");
                localStorage.removeItem("getPrivacyProfile");
                setShowVisibleResult(true);

            }
        })
    }



    return(
        <div className={`manage-privacy-style theme-${theme}`}>
            <ConfirmDialog />

            <Dialog
                className="result-privacy-popup"
                visible={showVisibleResult}
                modal={true}
                // header={headerElement}
                footer={footerContent}
                style={{ width: "22rem" }}
                closable={false}
                onHide={() => setShowVisibleResult(false)}>
                <p className="m-0">Aggiornamento avvenuto con successo</p>
            </Dialog>

            <div className={`bg-privacy ${isOnline ? '' : 'pb-3'} `}>

                {
                    process.env.REACT_APP_SUFFIX_TITLE_HEADER
                    ?
                    <div className="flex justify-content-start flex-wrap header-page-menu-no-production">
                        <div className="flex align-items-center justify-content-center header-content-menu">
                            { process.env.REACT_APP_SUFFIX_TITLE_HEADER }
                        </div>
                    </div>
                    :
                    <></>
                }

                {
                    (!dataManage?.forceUpdate) ?
                        <div className="flex justify-content-between align-items-center back-to-menu-style">
                            <div className="flex justify-content-start flex-wrap pr-4 pt-2">
                                <div
                                    className="flex align-items-center justify-content-right "
                                    style={{cursor:'pointer'}}
                                    onClick={() => {
                                        if(dataManage?.pathname === '/menu')
                                            //goTo('/menu')
                                            window.history.go(-1)
                                    }}
                                    >
                                    <div className="flex align-items-center justify-content-start ml-4 mt-2   " >
                                        <i className="pi pi-arrow-left mr-2 font-bold" style={{ fontSize: "1.6rem" }}></i>
                                        <div>Torna al menù</div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="flex align-items-center justify-content-end font-bold flex-wrap m-3"
                                style={{ cursor: "pointer" }}
                                
                            >
                            <i className='pi pi-times' style={{ fontSize: "1.9rem" }} onClick={() => {
                                if( localStorage.getItem('previousPath') === '/home' || 
                                    localStorage.getItem('previousPath') === '/menu' || 
                                    localStorage.getItem('previousPath') === '/' ){
                                    goTo("/home")
                                }else{
                                    // goTo(localStorage.getItem('previousPath') || "/menu" )
                                    window.history.go(-2)
                                }
                            }}>
                            </i>
                            </div>
                        </div>
                        
                    :
                    <></>
                }
                
                <div className="flex flex-column align-items-center">
                    <div className="title flex justify-content-center align-items-center ">
                        <i className="pi pi-lock mt-3 mb-2 p-4 text-xl icon-lock flex justify-content-center align-items-center "></i>
                    </div>
                    <div className="title flex justify-content-center align-items-center font-bold ">
                        Gestione Consensi
                    </div>
                    <div  className="mt-2 mx-4 flex text-lg storeNamePrivacyStyle">
                        {storeName}
                    </div>
                    {
                        storeName !== groupName ? (
                            <div className=" mx-4 flex text-sm ">
                                {groupName}
                            </div>
                        )
                        :
                        (
                            <></>
                        )
                    }

                    <div className="flex flex-column  mx-4 mt-4 bg-custom-menu text-white border-round relative"
                            style={{ border: "1px solid white" }}>
                                
                        <div className="flex flex-column p-2 ">

                                <div>
                                    <div className="text-area-privacy mb-3">
                                        <strong>MODALITA' DEL TRATTAMENTO</strong><br />
                                        Il trattamento dei dati avverrà con l’ausilio di strumenti elettronici e/o cartacei, secondo logiche strettamente correlate alle finalità sopra
                                        indicate e comunque adottando procedure e misure idonee a tutelarne la sicurezza e la riservatezza. <br />
                                        <br /><strong>FINALITA' DEL TRATTAMENTO</strong><br />
                                        Il trattamento dei dati sarà finalizzato allo svolgimento delle attività di seguito elencate:<br />
                                        a) rilascio della Carta Fedeltà e gestione delle attività non esercitabili in forma anonima e necessarie per consentire ai sottoscrittori la
                                        fruizione e il riconoscimento degli sconti e delle promozioni, l’offerta e l’invio di premi, la partecipazione a raccolte punti e l’accesso agli
                                        altri servizi accessori utilizzabili mediante la Carta;<br />
                                        b) svolgimento, previo Suo espresso consenso scritto, di attività di marketing diretto, quali l’invio - anche tramite e-mail, SMS, MMS ed
                                        APP - di materiale pubblicitario e di comunicazioni aventi contenuto informativo e/o promozionale in relazione a prodotti o servizi forniti
                                        e/o promossi dal Titolare o, per conto del Titolare, forniti/promossi dal Responsabile Esterno Fidelity Salus Service & Consulting srl, ivi
                                        compresi omaggi e campioni gratuiti;<br />
                                        c) svolgimento, previo Suo espresso consenso scritto, di attività di profilazione individuale o aggregata e di ricerche di mercato volte, ad
                                        esempio, all’analisi delle abitudini e delle scelte di consumo, all’elaborazione di statistiche sulle stesse o alla valutazione del grado di
                                        soddisfacimento rispetto ai prodotti ed ai servizi proposti. I dati trattati per finalità di profilazione o marketing possono essere conservati
                                        per un periodo non superiore ai 36 mesi dall’ultima transazione effettuata, salva la loro reale trasformazione in forma anonima che non
                                        permetta anche indirettamente di identificare gli interessati. Nel caso di eventuale ritiro, disabilitazione per mancato utilizzo entro un
                                        determinato arco temporale, scadenza o restituzione della carta, deve essere individuato un termine di conservazione dei dati personali
                                        per esclusive finalità amministrative (e non anche di profilazione e marketing) non superiore ad un trimestre.<br />
                                        <br /><strong>CONSENSO AL TRATTAMENTO DEI DATI PERSONALI</strong><br />
                                        Letta la presente informativa, il/la sottoscritto/a dichiara di averne compreso il contenuto. Le facciamo presente che la manifestazione del
                                        Suo consenso espresso all’effettuazione del trattamento dei Suoi dati personali, da parte del Titolare., finalizzato al rilascio della Carta
                                        Fedeltà ed alla gestione delle attività non esercitabili in forma anonima e necessarie per consentire ai sottoscrittori la fruizione e il
                                        riconoscimento degli sconti e delle promozioni, l’offerta e l’invio di premi, la partecipazione a Raccolte Punti e l’accesso agli altri servizi
                                        accessori utilizzabili mediante la Carta, è superflua. Il trattamento dei dati preordinato alla fidelizzazione in senso stretto è necessario per
                                        eseguire obblighi derivanti da un contratto del quale è parte l’interessato (art.6,7,8,9 Regolamento Privacy UE 2016/679)
                                    </div>
                                    <div className="mb-4 mx-1 text-sm">
                                        Il/La sottoscritto/a dichiara inoltre di prestare il proprio specifico consenso scritto al trattamento dei dati per le ulteriori finalità di marketing e 
                                        profilazione ed in particolare:
                                    </div>
                                </div>

                            
                                <div className="text-sm pb-3 mx-1 pr-2 flex" > 
                                    <div className="text-3xl mr-2 container-number">1</div>
                                    <div className="single-privacy-box">
                                        Lo svolgimento di attività di profilazione individuale o aggregata e di ricerche di mercato volte, ad esempio, all’analisi delle abitudini e delle scelte di consumo, all’elaborazione di statistiche sulle stesse o alla valutazione del grado di soddisfacimento dei prodotti e dei servizi proposti. 
                                    </div> 
                                </div>
                                <div className="flex justify-content-start align-items-center ml-6 mb-6">
                                    <Checkbox className="mr-1" checked={privacy1} value={privacy1} onChange={onChangePrivacy1} ></Checkbox>
                                    <label>Acconsento</label>
                                </div>  

                                <div className="text-sm pb-3 mx-1 pr-2 flex" >
                                    <div className="text-3xl mr-2 container-number">2</div>                       
                                    <div className="single-privacy-box"> 
                                        Lo svolgimento di attività di marketing diretto, quali l’invio - anche tramite e-mail, SMS, MMS e APP - di materiale pubblicitario e di comunicazioni aventi contenuto informativo e/o promozionale in relazione a prodotti o servizi forniti e/o promossi dal Titolare o dai Responsabili Esterni quali Fidelity Salus Service & Consulting srl, ivi compresi omaggi e campioni gratuiti 
                                    </div>
                                </div>
                                <div className="flex justify-content-start align-items-center ml-6 mb-6">
                                    <Checkbox className="mr-1" checked={privacy2} value={privacy2} onChange={onChangePrivacy2}  ></Checkbox>
                                    <label>Acconsento</label>
                                </div>

                            {
                                privacyInfo?.privacy3App
                                ?
                                <>
                                  <div className="text-sm pb-3 mx-1 pr-2 flex" >
                                    <div className="text-3xl mr-2 container-number">3</div>                       
                                    <div className="single-privacy-box"> 
                                        { privacyInfo.privacy3App.name }
                                    </div>
                                    </div>
                                    <div className="flex justify-content-start align-items-center ml-6 mb-6">
                                    <Checkbox className="mr-1" checked={privacy3 ? true : false} value={privacy3} onChange={onChangePrivacy3} >
                                    </Checkbox>
                                        <label>Acconsento</label>
                                    </div>
                                </>
                                :
                                <></>
                            }
                           

                        </div>
                        
                        <div className="flex justify-content-end align-items-center pb-2 pr-2 date-color">
                            <div className="flex flex-column " >

                                {
                                    privacyInfo?.lastPrivacyUpdateDate 
                                    ?
                                    <div className="flex justify-content-end align-items-center text-sm " >
                                        <div className="">Ultima impostazione privacy: &nbsp;</div>
                                        <div> { moment(privacyInfo.lastPrivacyUpdateDate).format("DD/MM/YYYY") } </div>
                                    </div>
                                    :
                                    <div className="select-none">&nbsp;</div>
                                }

                                {
                                    privacyInfo?.privacyExpirationDate
                                    ?
                                    <div className="flex justify-content-end align-items-center text-sm ">
                                        <div>Scadenza privacy: &nbsp;</div>
                                        <div> { moment(privacyInfo.privacyExpirationDate).format("DD/MM/YYYY") } </div>
                                    </div>
                                    :
                                    <div className="select-none">&nbsp;</div>
                                }
                
                            </div>                    
                        </div>
                        <div className="footer-privacy ">
                            {/* <div className="footer-privacy-after">

                            </div> */}
                        </div>
                    </div>

                </div>
                

                <div className=" mt-3 ml-4 flex justify-content-start align-items-center" style={{cursor:'pointer'}} onClick={() => { downloadPdfPrivacy() }}>
                    <i className="pi pi-download mr-2 " ></i>
                    Informativa Privacy
                </div>

                <div className="flex justify-content-end align-items-center py-5 mr-3">

                    {
                                        
                            (!dataManage?.forceUpdate) ?
                            <Button
                                onClick={() => {
                                    if(dataManage?.pathname === '/menu')
                                        // goTo('/menu')
                                        window.history.go(-1)
                                    else{
                                        goTo('home')
                                    }
                                }}
                                label="Annulla"
                                //disabled={}
                                style={{ borderRadius: "24px" }}
                                className="button-undo-privacy mx-2  flex align-items-center justify-content-center"
                            ></Button>
                        :
                            <></>
                    }
                    
                    <Button
                        onClick={() => {
                            confirmSaveSetting()
                        }}
                        label="Conferma"
                        //disabled={}
                        style={{ borderRadius: "24px" }}
                        className="button-edit-privacy mx-2  flex align-items-center justify-content-center"
                    ></Button>

                </div>


            {/* L' ho nascondo in maniera tale che l' icona viene sempre caricata */}


            </div>
            
        </div>
    )




}